export function formatPlain(num: number | string): string {
  let str = String(num);
  if (str.includes('e') || str.includes('E')) {
    const parts = str.toLowerCase().split('e');
    const mantissa = parts[0];
    const exponent = parseInt(parts[1], 10);
    if (exponent < 0) {
      const sign = mantissa.startsWith('-') ? '-' : '';
      const absMantissa = mantissa.replace('-', '').replace('.', '');
      const zeros = '0.' + '0'.repeat(Math.abs(exponent) - 1);
      str = sign + zeros + absMantissa;
    } else {
      // Handle positive exponents if necessary, but usually we just care about small fractions
      return Number(num).toLocaleString('fullwide', { useGrouping: false });
    }
  }
  return str;
}

export function formatSubscript(num: number | string): string {
  if (num === undefined || num === null || (typeof num === 'number' && isNaN(num))) return '0.00';
  const val = Number(num);
  if (val === 0) return '0.00';
  if (val >= 1000) return val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
  let plainStr = formatPlain(num).replace(/0+$/, '');
  const match = plainStr.match(/^0\.0+/);
  if (match) {
    const zeroCount = match[0].length - 2; 
    if (zeroCount >= 5) {
      const subscripts = ['₀', '₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉'];
      const countStr = zeroCount.toString().split('').map(d => subscripts[parseInt(d)]).join('');
      const sigDigits = plainStr.slice(match[0].length).slice(0, 4);
      return `0.0${countStr}${sigDigits}`;
    }
  }

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8
  }).format(val);
}
